import { connect } from "react-redux";

import * as actions from "../actions/actions";
import React from "react";

import NounProjectSearch from "./nounproject-search";
require("../../sass/components/nounproject-navigation.sass");

let UserStore = require("../legacy/stores/userstore").default; // temporary. Create redux user store

class NounProjectNavigation extends React.Component {
    static defaultProps = {
        noSearch: false
    };
    static propTypes = {
        noSearch: React.PropTypes.bool.isRequired
    };

    authUser() {
        if (UserStore.getAll().user.is_anonymous === false) {
            return this.setState({
                user: this.normalizeUserData()
            });
        }
    }

    componentWillMount() {
        // TODO: add to redux stores
        this.props.getCurrentUser();

        // always scroll user to top
        if ($(window).scrollTop() > 0) {
            window.scrollTo(0, 0);
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            showNavigation: false,
            showUserMenu: false,
            scope: !props.args ? undefined : this.props.args.scope,
            user: this.normalizeUserData()
        };
    }

    normalizeUserData() {
        let userData = UserStore.getAll().user;

        if (!userData.is_anonymous) {
            if (userData.teams) {
                userData.teams.forEach(team => {
                    team.name = team.name.replace("%27", "'");
                });
            }
        }
        return userData;
    }

    hideMenus(e) {
        // hide both menus
        this.toggleStaticNavigation("hide");
        this.toggleUserNavigation("hide");
    }

    logIn(e) {
        window.location = "/accounts/login/";
    }

    logOut(e) {
        e.preventDefault();

        $("#logout-form").submit();
    }

    render() {
        let staticMenuOpenStyle = {
            left: "-250px"
        };

        let userNavigationIcon = this.renderUserNavigationIcon(),
            userNavigation = this.renderUserNavigation();

        if (this.state.showNavigation) {
            staticMenuOpenStyle = {
                left: 0
            };
        }

        let searchComponent = this.renderSearch(),
            navigationHeaderClasses = ["navigation-header"];

        if (this.state.showUserMenu || this.state.showNavigation) {
            navigationHeaderClasses.push("menu-is-shown");
        } else {
            navigationHeaderClasses.push("menu-is-not-shown");
        }

        return (
            <div onMouseLeave={this.hideMenus.bind(this)}>
                <nav className={navigationHeaderClasses.join(" ")}>
                    <div className="row">
                        <a
                            className="main-navigation ui_logo col-lg-1 col-md-1 col-sm-1 col-xs-3"
                            onMouseEnter={this.toggleStaticNavigation.bind(
                                this,
                                "show"
                            )}
                            href="/"
                            title="Noun Project Homepage"
                        />
                        <div className="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                            {searchComponent}
                        </div>
                        {userNavigationIcon}
                    </div>
                </nav>
                <nav
                    className="side-menu static-navigation"
                    style={{
                        ...staticMenuOpenStyle
                    }}
                >
                    <div style={{ minHeight: "77px" }} />
                    <div
                        style={{
                            overflow: "auto",
                            height: "100%",
                            paddingBottom: "100px"
                        }}
                    >
                        <ul>
                            <li className="list-header">
                                <a href="/" title="Noun Project">
                                    Noun Project
                                </a>
                            </li>
                            <li>
                                <a href="/about/" title="About">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="/creators/" title="Icon Creators">
                                    Icon Creators
                                </a>
                            </li>
                            <li>
                                <a
                                    href="//blog.thenounproject.com"
                                    title="Blog"
                                >
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a
                                    href="//iconathon.org"
                                    title="Iconathon"
                                    target="_blank"
                                >
                                    Iconathon
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li className="list-header">Pricing</li>
                            <li>
                                <a href="/pricing/" title="NounPro Pricing">
                                    NounPro
                                </a>
                            </li>
                            <li>
                                <a href="/team/" title="Teams Pricing">
                                    Teams
                                </a>
                            </li>
                            <li>
                                <a href="/for-edu/" title="Education Pricing">
                                    Education
                                </a>
                            </li>
                        </ul>

                        <ul>
                            <li className="list-header">Products</li>
                            <li>
                                <a href="/apps/" title="Apps &amp; Plugins">
                                    Apps &amp; Plugins
                                </a>
                            </li>
                            <li>
                                <a href="/developers/" title="Icon API">
                                    Icon API
                                </a>
                            </li>
                            <li>
                                <a href="/nounji/" title="Nounji for iMessages">
                                    Nounji
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://lingoapp.com"
                                    title="Lingo"
                                    target="_blank"
                                >
                                    Lingo
                                </a>
                            </li>
                        </ul>
                        <ul className="secondary">
                            <li>
                                <a href="/jobs/" title="Jobs">
                                    Jobs
                                </a>
                            </li>
                            <li>
                                <a href="/legal/" title="Legal">
                                    Legal
                                </a>
                            </li>
                            <li>
                                <a
                                    href="//thenounproject.zendesk.com"
                                    title="Support"
                                >
                                    Customer Support
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
                {userNavigation}
            </div>
        );
    }

    renderCreatorMenu() {
        let activityFeed = null;
        if (this.state.user.has_notifications) {
            activityFeed = <span className="ui_notifications margin-l-s" />;
        }

        let userData,
            creatorMenu = (
                <ul>
                    <li className="list-header">
                        <a href="/dashboard/">Your Icons</a>
                    </li>
                    <li>
                        <a
                            href={`/${
                                this.props.currentUser.username
                            }/activity/`}
                            title="Activity"
                        >
                            Activity
                            {activityFeed}
                        </a>
                    </li>
                    <li>
                        <a href="/upload/" title="Upload">
                            Upload
                        </a>
                    </li>
                    <li>
                        <a
                            href={`/${
                                this.props.currentUser.username
                            }/royalties/`}
                            title="Royalties"
                        >
                            Royalties
                        </a>
                    </li>
                    <li>
                        <a href="/dashboard/uploads/" title="Your Icons">
                            Your Icons
                        </a>
                    </li>
                    <li>
                        <a
                            href={`/${
                                this.props.currentUser.username
                            }/collections/`}
                            title="Collections"
                        >
                            Collections
                        </a>
                    </li>
                </ul>
            ),
            nonCreatorMenu = (
                <ul>
                    <li className="list-header">
                        <a href="/creators/" title="Learn More">
                            Become a Creator
                        </a>
                    </li>
                    <li>
                        <a href="/creators/" title="Learn More">
                            Learn More
                        </a>
                    </li>
                    <li>
                        <a href="/handbook/" title="Creator Handbook">
                            Creator Handbook
                        </a>
                    </li>
                </ul>
            );

        if (this.state.user.creator) {
            userData = creatorMenu;
        } else {
            userData = nonCreatorMenu;
        }

        return userData;
    }

    renderUserNavigation() {
        if (this.props.currentUser) {
            let billingUpgrade = (
                    <li>
                        <a href={`/settings/billing/`} title="Billing">
                            Billing
                        </a>
                    </li>
                ),
                fortMenu,
                userMenuOpenStyle = {
                    right: "-250px"
                },
                userNav;

            if (this.state.showUserMenu) {
                userMenuOpenStyle = {
                    right: 0
                };
            }

            if (this.props.currentUser.is_superuser) {
                fortMenu = (
                    <ul>
                        <li className="list-header">Admin Fort</li>
                        <li>
                            <a href="/fort/modparty/" title="Moderation">
                                Moderation
                            </a>
                        </li>
                        <li>
                            <a href="/fort/members/" title="Members">
                                Members
                            </a>
                        </li>
                        <li>
                            <a href="/fort/icon/" title="Icons">
                                Icons
                            </a>
                        </li>
                        <li>
                            <a href="/fort/collections/" title="Collections">
                                Collections
                            </a>
                        </li>
                    </ul>
                );
            }

            if (
                this.props.currentUser.permissions &&
                this.props.currentUser.permissions.market !== "premium"
            ) {
                billingUpgrade = (
                    <li>
                        <a href={`/accounts/upgrade/`} title="Upgrade">
                            Upgrade
                        </a>
                    </li>
                );
            }

            let userData = this.renderCreatorMenu(),
                teamInfo = this.renderTeamInfo();

            return (
                <nav
                    className="side-menu user-navigation"
                    style={{ ...userMenuOpenStyle }}
                >
                    <div style={{ minHeight: "77px" }} />
                    <div
                        style={{
                            overflow: "auto",
                            height: "100%",
                            paddingBottom: "100px"
                        }}
                    >
                        {fortMenu}
                        <ul>
                            <li className="list-header">
                                <a href="/dashboard/">Dashboard</a>
                            </li>
                            <li>
                                <a
                                    href={`/${
                                        this.props.currentUser.username
                                    }/settings/icon-history/`}
                                    title="Icon History"
                                >
                                    Icon History
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/${
                                        this.props.currentUser.username
                                    }/settings/basics/`}
                                    title="Settings"
                                >
                                    Settings
                                </a>
                            </li>
                            {billingUpgrade}
                            <li>
                                <a
                                    href={`/${
                                        this.props.currentUser.username
                                    }/settings/invoices/`}
                                    title="Invoices"
                                >
                                    Invoices
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/${
                                        this.props.currentUser.username
                                    }/kits/`}
                                    title="Kits"
                                >
                                    Kits
                                </a>
                            </li>
                        </ul>
                        {userData}
                        {teamInfo}
                        <ul className="secondary">
                            <li>
                                <a
                                    href="/logout/"
                                    title="Logout"
                                    onClick={this.logOut.bind(this)}
                                >
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            );
        } else {
            return null;
        }
    }

    renderUserNavigationIcon() {
        let avatarContainerClasses = ["avatar-container"],
            avatarStyles = {
                borderRadius: "50%",
                position: "relative",
                width: "40px",
                alignSelf: "flex-end"
            },
            loggedOutIconStyle = {
                textAlign: "center"
            },
            userNavigationIcon,
            userNavigationStyles = {
                position: "relative"
            };

        if (this.props.currentUser && !this.props.currentUser.is_anonymous) {
            let userNavigationClasses =
                "user-navigation col-lg-1 col-md-1 col-sm-1 col-xs-12 ";
            if (this.props.currentUser.has_notifications) {
                avatarContainerClasses.push("ui_notifications");
            }
            userNavigationIcon = (
                <div
                    className={userNavigationClasses}
                    style={userNavigationStyles}
                    onMouseEnter={this.toggleUserNavigation.bind(this, "show")}
                >
                    <div className={avatarContainerClasses.join(" ")}>
                        <img
                            className={"avatar"}
                            src={this.props.currentUser.avatar}
                            style={avatarStyles}
                        />
                    </div>
                </div>
            );
        } else {
            userNavigationIcon = (
                <div
                    className="user-navigation col-lg-1 col-md-1 col-sm-1 col-xs-12"
                    style={userNavigationStyles}
                >
                    <a
                        href="/accounts/login/"
                        title="log in"
                        onClick={this.logIn.bind(this)}
                        style={loggedOutIconStyle}
                    >
                        <div className="ui_key" />
                        Log in
                    </a>
                </div>
            );
        }

        return userNavigationIcon;
    }

    renderSearch() {
        let searchComponent;

        if (!this.props.noSearch) {
            let query;

            if (this.props.args) {
                query = this.props.args.query;
            }

            searchComponent = (
                <NounProjectSearch scope={this.state.scope} query={query} />
            );
        }

        return searchComponent;
    }

    renderTeamInfo() {
        let teamInfo = [];

        if (this.state.user.teams) {
            this.state.user.teams.forEach(team => {
                teamInfo.push(
                    <ul key={this.state.user.teams.indexOf(team)}>
                        <li className="list-header">{team.name}</li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/seats/`}
                                title="Team Seats"
                            >
                                Team Seats
                            </a>
                        </li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/billing/`}
                                title="Team Billing"
                            >
                                Team Billing
                            </a>
                        </li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/invoices/`}
                                title="Team Invoices"
                            >
                                Team Invoices
                            </a>
                        </li>
                    </ul>
                );
            });
        }

        return teamInfo;
    }

    toggleStaticNavigation(action) {
        if (action === "hide") {
            this.setState({
                showNavigation: false
            });
        } else {
            this.setState({
                showNavigation: true
            });
        }
    }

    toggleUserNavigation(action) {
        if (action === "hide") {
            this.setState({
                showUserMenu: false
            });
        } else {
            this.setState({
                showUserMenu: true
            });
        }
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return { currentUser };
}

// export default Icon_List;
module.exports = connect(
    mapStateToProps,
    {
        getCurrentUser: actions.getCurrentUser
    }
)(NounProjectNavigation);
